import { usePractitioner } from "@repo/data-store";
import { practitionerDisplayName } from "@/shared/lib/practitioner-utils";
import { RoleBadge } from "@/shared/status/role-badge";

interface PractitionerDisplayProps {
  practitionerId?: string;
  fallbackDisplay?: string | null;
  showRole?: boolean;
}

export function PractitionerDisplay({ practitionerId, fallbackDisplay, showRole = true }: PractitionerDisplayProps) {
  const { practitioner } = usePractitioner(practitionerId);

  const name = practitionerDisplayName(practitioner) ?? fallbackDisplay ?? null;
  if (!name) return null;

  return (
    <span className="inline-flex items-center gap-1.5">
      <span>{name}</span>
      {showRole && practitioner?.role && <RoleBadge role={practitioner.role} />}
    </span>
  );
}
